// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.measureQuick--ETszN {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
}

.measureQuick--ETszN h6 {
  flex-basis: 100%;
}

.measureQuickButton--tizkA {
  position: relative;
}

[dir=ltr] .measureQuickButton--tizkA {
  margin-right: 14px;
  padding: 6px 5px 6px 3px;
}

[dir=rtl] .measureQuickButton--tizkA {
  margin-left: 14px;
  padding: 6px 3px 6px 5px;
}

@media screen and (min-width: 768px) {
  .measureQuick--ETszN {
    display: inline-flex;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SubjectPickerMenu/SubComponents/QuickSelectionButtons/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,kBAAkB;AACpB;;AAJA;EACE,kBAAkB;EAClB,wBAAwB;AAE1B;;AAJA;EACE,iBAAkB;EAClB,wBAAwB;AAE1B;;AAEA;EACE;IACE,oBAAoB;IACpB,mBAAmB;EACrB;AACF","sourcesContent":[".measureQuick {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: center;\n}\n\n.measureQuick h6 {\n  flex-basis: 100%;\n}\n\n.measureQuickButton {\n  margin-right: 14px;\n  padding: 6px 5px 6px 3px;\n  position: relative;\n}\n\n@media screen and (min-width: 768px) {\n  .measureQuick {\n    display: inline-flex;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"measureQuick": `measureQuick--ETszN`,
	"measureQuickButton": `measureQuickButton--tizkA`
};
export default ___CSS_LOADER_EXPORT___;
